import { render } from "./IconChevronRight.vue?vue&type=template&id=72033216"
const script = {}

import "./IconChevronRight.vue?vue&type=style&index=0&id=72033216&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__